import { useCustomer } from '~/techstyle-shared/react-accounts';

export default function useStoreLocation() {
  const { retailStores = [] } = useCustomer();
  const storeLocation = retailStores.find(
    (storeInfo) =>
      storeInfo.address && storeInfo.address.city && storeInfo.address.state
  );

  return {
    storeLocation,
  };
}
